/* ITIRA theme JavaScript. Native custom elements, no dependencies. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animate = document.body.dataset.animations !== 'false' && !reduceMotion;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = (window.itira && window.itira.routes) || {};
  var strings = (window.itira && window.itira.strings) || {};

  /* ------------------------------------------------------------------ */
  /* Loader                                                              */
  /* ------------------------------------------------------------------ */
  var loader = $('[data-loader]');
  var readyFired = false;
  function fireReady() {
    if (readyFired) return;
    readyFired = true;
    document.documentElement.classList.add('is-ready');
    document.dispatchEvent(new CustomEvent('itira:ready'));
  }
  function finishLoader() {
    try { sessionStorage.setItem('itira-loaded', '1'); } catch (e) {}
    if (!loader) { fireReady(); return; }
    loader.classList.add('is-done');
    setTimeout(fireReady, 350);
    setTimeout(function () { loader.classList.add('is-gone'); }, 1200);
  }
  if (!loader || document.documentElement.classList.contains('no-loader') || reduceMotion) {
    if (loader) loader.classList.add('is-gone');
    fireReady();
  } else {
    var started = performance.now();
    var minTime = 1400;
    var go = function () {
      var wait = Math.max(0, minTime - (performance.now() - started));
      setTimeout(finishLoader, wait);
    };
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go);
    setTimeout(finishLoader, 6000);
  }

  /* ------------------------------------------------------------------ */
  /* Fabric fold: <fabric-fold mode="load|scroll">                       */
  /* ------------------------------------------------------------------ */
  function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  class FabricFold extends HTMLElement {
    connectedCallback() {
      this.mode = this.getAttribute('mode') || 'load';
      if (!animate) { this.style.setProperty('--u', 1); return; }
      this.style.setProperty('--u', 0);
      if (this.mode === 'scroll') {
        this.onScroll = this.update.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      } else {
        this.unfoldOnce = this.unfoldOnce.bind(this);
        if (document.documentElement.classList.contains('is-ready')) this.unfoldOnce();
        else document.addEventListener('itira:ready', this.unfoldOnce, { once: true });
        // Optional scroll-out: fold gently back as the hero leaves the viewport
        this.onScrollOut = this.scrollOut.bind(this);
        window.addEventListener('scroll', this.onScrollOut, { passive: true });
      }
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('scroll', this.onScrollOut);
    }
    unfoldOnce() {
      var start = null, dur = 2200, self = this;
      this.opening = true;
      function step(ts) {
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / dur);
        self.style.setProperty('--u', ease(t).toFixed(4));
        if (t < 1) requestAnimationFrame(step); else { self.opening = false; self.scrollOut(); }
      }
      requestAnimationFrame(step);
    }
    scrollOut() {
      if (this.opening) return;
      var r = this.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, -r.top / (r.height * 0.9)));
      this.style.setProperty('--u', (1 - 0.35 * p).toFixed(4));
    }
    update() {
      var r = this.getBoundingClientRect(), vh = window.innerHeight;
      // 0 when the top edge enters at the bottom, 1 when the element is about 35% up the screen
      var p = (vh - r.top) / (vh * 0.65 + 1);
      this.style.setProperty('--u', ease(Math.min(1, Math.max(0, p))).toFixed(4));
    }
  }
  customElements.define('fabric-fold', FabricFold);

  /* Scroll-unfold for any element with [data-drape] */
  var drapes = $$('[data-drape]');
  if (drapes.length) {
    if (!animate) drapes.forEach(function (el) { el.style.setProperty('--u', 1); });
    else {
      var ticking = false;
      var updateDrapes = function () {
        ticking = false;
        var vh = window.innerHeight;
        drapes.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          var p = (vh - r.top) / (vh * 0.55 + 1);
          el.style.setProperty('--u', ease(Math.min(1, Math.max(0, p))).toFixed(3));
        });
      };
      drapes.forEach(function (el) { el.style.setProperty('--u', 0); });
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(updateDrapes); } }, { passive: true });
      window.addEventListener('resize', updateDrapes);
      updateDrapes();
    }
  }

  /* ------------------------------------------------------------------ */
  /* Reveal on scroll                                                    */
  /* ------------------------------------------------------------------ */
  var reveals = $$('.reveal');
  if (reveals.length) {
    if (!animate || !('IntersectionObserver' in window)) reveals.forEach(function (el) { el.classList.add('is-in'); });
    else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Drawers                                                             */
  /* ------------------------------------------------------------------ */
  var lastTrigger = null;
  function openDrawer(name, trigger) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return;
    lastTrigger = trigger || document.activeElement;
    d.classList.add('is-open');
    d.removeAttribute('aria-hidden');
    document.body.classList.add('is-locked');
    $$('[data-drawer-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var focusTarget = $('[data-autofocus]', d) || $('button, a, input', d.querySelector('.drawer__panel'));
    setTimeout(function () { if (focusTarget) focusTarget.focus(); }, 60);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('is-locked');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) {
      var name = open.dataset.drawerOpen;
      if (name === 'cart' && document.body.dataset.cartType === 'page') return; // follow link
      e.preventDefault();
      openDrawer(name, open);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) {
    var d = $('.drawer.is-open');
    if (!d) return;
    if (e.key === 'Escape') { closeDrawers(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', d).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  /* ------------------------------------------------------------------ */
  /* Toast                                                               */
  /* ------------------------------------------------------------------ */
  var toastTimer;
  function toast(msg, isError) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    t.classList.toggle('toast--error', !!isError);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }

  /* ------------------------------------------------------------------ */
  /* Cart                                                                */
  /* ------------------------------------------------------------------ */
  function renderCartSections(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer-content]', doc);
    var cur = $('[data-cart-drawer-content]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var count = fresh ? parseInt(fresh.dataset.itemCount || '0', 10) : 0;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
      el.classList.remove('is-bumping');
      void el.offsetWidth;
      el.classList.add('is-bumping');
    });
  }
  function refreshCart() {
    return fetch(routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { renderCartSections(j['cart-drawer']); });
  }
  function cartChange(line, quantity) {
    var cur = $('[data-cart-drawer-content]');
    if (cur) cur.classList.add('cart-loading');
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (j.status && j.description) { toast(j.description, true); }
      if (j.sections && j.sections['cart-drawer']) renderCartSections(j.sections['cart-drawer']);
      else return refreshCart();
    }).finally(function () { if (cur) cur.classList.remove('cart-loading'); });
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); cartChange(parseInt(rm.dataset.line, 10), 0); return; }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var wrap = step.closest('[data-qty]');
      var input = $('input', wrap);
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
      var max = parseInt(input.max || '0', 10);
      if (max && next > max) { toast(strings.qtyError.replace('__MAX__', max), true); return; }
      input.value = next;
      if (input.dataset.line) cartChange(parseInt(input.dataset.line, 10), next);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty] input[data-line]');
    if (input) cartChange(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  // Add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    var submitter = e.submitter;
    if (submitter && submitter.dataset.buyNow !== undefined) return; // dynamic checkout button
    if (document.body.dataset.cartType === 'page') return; // normal form post
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var label = btn.querySelector('[data-label]');
    var original = label ? label.textContent : btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    if (label) label.textContent = strings.adding;
    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) { toast(j.description || j.message, true); return; }
        if (j.sections && j.sections['cart-drawer']) renderCartSections(j.sections['cart-drawer']);
        else refreshCart();
        openDrawer('cart', btn);
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        btn.removeAttribute('aria-disabled');
        if (label) label.textContent = original;
      });
  });

  /* ------------------------------------------------------------------ */
  /* Header: transparent over the home hero, solid once past it          */
  /* ------------------------------------------------------------------ */
  var header = $('[data-header]');
  if (header && header.hasAttribute('data-overlay')) {
    var hero = $('.hero');
    var heading = hero && $('h1', hero);
    var headerTicking = false;
    var HOLD = 0.78; // how solid the header is while the hero is behind it
    // Fade in to HOLD as the hero heading reaches the menu, keep it there,
    // then finish to fully solid over the last stretch before the end of the hero.
    var setSolid = function () {
      headerTicking = false;
      var y = window.scrollY;
      var h = header.offsetHeight;
      var end = hero ? hero.offsetTop + hero.offsetHeight - h : 40;
      // Scroll position at which the heading's top meets the bottom of the sticky header
      var reach = heading ? heading.getBoundingClientRect().top + y - h : end / 3;
      reach = Math.min(Math.max(reach, 1), end - h);
      var b;
      if (y >= end) b = 1;
      else if (y >= end - h) b = HOLD + (1 - HOLD) * (y - (end - h)) / h;
      else b = HOLD * Math.min(1, Math.max(0, y / reach));
      header.style.setProperty('--b', b.toFixed(3));
      header.classList.toggle('is-solid', y >= end);
    };
    var onScroll = function () {
      if (!headerTicking) { headerTicking = true; window.requestAnimationFrame(setSolid); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    setSolid();
  }

  /* ------------------------------------------------------------------ */
  /* Product page: gallery and variants                                  */
  /* ------------------------------------------------------------------ */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.slides = $$('[data-slide]', this);
      this.thumbs = $$('[data-thumb]', this);
      this.thumbs.forEach(function (t, i) { t.addEventListener('click', function () { self.show(i, true); }); });
      this.track = $('[data-track]', this);
      if (this.track) {
        var t;
        this.track.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
            self.mark(i);
          }, 80);
        }, { passive: true });
      }
    }
    mark(i) {
      this.thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      var c = $('[data-counter]', this);
      if (c) c.textContent = (i + 1) + ' / ' + this.slides.length;
    }
    show(i, scroll) {
      if (!this.slides[i]) return;
      this.mark(i);
      if (scroll && this.track) this.track.scrollTo({ left: this.slides[i].offsetLeft - this.track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    showMedia(id) {
      for (var i = 0; i < this.slides.length; i++) { if (this.slides[i].dataset.mediaId == id) { this.show(i, true); return; } }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.addEventListener('change', function () { self.update(); });
    }
    update() {
      var section = this.closest('[data-section-id]');
      var form = this.closest('form') || $('form[data-product-form]', section);
      var checked = $$('input:checked, select', this);
      var options = checked.map(function (i) { return i.value; });
      var url = this.dataset.url;
      var sectionId = section.dataset.sectionId;
      var variants = JSON.parse($('script[type="application/json"]', this).textContent);
      var match = variants.filter(function (v) { return v.options.join('|') === options.join('|'); })[0];
      $$('fieldset', this).forEach(function (group, i) {
        var chosen = $('[data-chosen]', group);
        if (chosen && options[i] != null) chosen.textContent = options[i];
      });
      var idInput = $('[name="id"]', form);
      var addBtn = $('[data-add-button]', form);
      var label = addBtn && addBtn.querySelector('[data-label]');
      if (!match) {
        if (addBtn) { addBtn.disabled = true; if (label) label.textContent = strings.unavailable; }
        return;
      }
      this.markAvailability(variants, options);
      idInput.value = match.id;
      if (addBtn) { addBtn.disabled = !match.available; if (label) label.textContent = match.available ? strings.addToCart : strings.soldOut; }
      var buyNow = $('[data-buy-now]', form);
      if (buyNow) buyNow.hidden = !match.available;
      history.replaceState({}, '', url + '?variant=' + match.id);
      var gallery = $('product-gallery', section);
      if (gallery && match.media_id) gallery.showMedia(match.media_id);
      fetch(url + '?variant=' + match.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-price]', '[data-stock]', '[data-sku]'].forEach(function (sel) {
            var a = $(sel, doc), b = $(sel, section);
            if (a && b) b.innerHTML = a.innerHTML;
          });
        });
    }
    /* Marks each option value as sold out when no available variant has it alongside the other current choices */
    markAvailability(variants, options) {
      $$('fieldset', this).forEach(function (group, i) {
        $$('.picker__input', group).forEach(function (input) {
          var wanted = options.slice(); wanted[i] = input.value;
          var ok = variants.some(function (v) { return v.available && v.options.join('|') === wanted.join('|'); });
          var lab = input.nextElementSibling;
          if (!lab) return;
          lab.classList.toggle('is-soldout', !ok);
          var note = $('[data-soldout-note]', lab);
          if (note) note.hidden = ok;
        });
      });
    }
  }
  customElements.define('variant-picker', VariantPicker);

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (!('IntersectionObserver' in window)) return this.load();
      new IntersectionObserver(function (es, o) { if (es[0].isIntersecting) { o.disconnect(); self.load(); } }, { rootMargin: '300px' }).observe(this);
    }
    load() {
      var self = this;
      fetch(this.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = $('product-recommendations', doc);
        if (src && src.innerHTML.trim()) self.innerHTML = src.innerHTML; else self.closest('section').hidden = true;
      });
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* Collection filters auto-submit */
  document.addEventListener('change', function (e) {
    var f = e.target.closest('[data-filter-form]');
    if (!f || e.target.closest('[data-no-auto]')) return;
    clearTimeout(f._t);
    f._t = setTimeout(function () { f.submit(); }, 250);
  });
  var sortSel = $('[data-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sortSel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* Preselect country on address forms */
  $$('select[name="address[country]"][data-default]').forEach(function (sel) {
    if (sel.dataset.default) sel.value = sel.dataset.default;
  });

  /* ------------------------------------------------------------------ */
  /* Saree reveal: <saree-reveal> unrolls a cloth while scrolling and   */
  /* switches on the "Why ITIRA" points one by one.                      */
  /* ------------------------------------------------------------------ */
  class SareeReveal extends HTMLElement {
    connectedCallback() {
      if (!animate) return; // stays fully open and static
      this.classList.add('is-live');
      this.points = $$('.sr__point', this).concat($$('.sr__cta', this));
      this.n = this.points.length;
      this.tick = false;
      this.onScroll = function () {
        if (this.tick) return;
        this.tick = true;
        requestAnimationFrame(this.update.bind(this));
      }.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
    update() {
      this.tick = false;
      var r = this.getBoundingClientRect();
      var span = Math.max(1, r.height - window.innerHeight);
      var p = Math.min(1, Math.max(0, -r.top / span));
      // the cloth drops during the first 85% of the scroll, then rests
      var drop = ease(Math.min(1, p / 0.85));
      this.style.setProperty('--p', drop.toFixed(4));
      this.style.setProperty('--sway', (Math.sin(p * 18) * 1.6 * (1 - drop * 0.6)).toFixed(3));
      var n = this.n, i;
      for (i = 0; i < n; i++) {
        var on = drop > 0.1 + (i / n) * 0.82;
        this.points[i].classList.toggle('is-on', on);
      }
    }
  }
  customElements.define('saree-reveal', SareeReveal);
})();


/* Live product search on the products page */
class LiveSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.box = this.querySelector('.lsearch__results');
    this.status = this.querySelector('[data-status]');
    this.limit = this.dataset.limit || 6;
    this.timer = null;
    this.ctrl = null;
    this.input.addEventListener('input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.run(), 250); });
    this.input.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); if (e.key === 'ArrowDown') { const a = this.box.querySelector('a'); if (a) { e.preventDefault(); a.focus(); } } });
    this.box.addEventListener('keydown', (e) => {
      const items = [...this.box.querySelectorAll('a')]; const i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && items[i + 1]) { e.preventDefault(); items[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || this.input).focus(); }
      if (e.key === 'Escape') { this.close(); this.input.focus(); }
    });
    document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.close(); });
  }
  close() { this.box.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
  async run() {
    const q = this.input.value.trim();
    if (q.length < 2) { this.close(); return; }
    if (this.ctrl) this.ctrl.abort();
    this.ctrl = new AbortController();
    const url = window.itira.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + this.limit + '&resources[options][fields]=title,product_type,variants.title,tag';
    try {
      const res = await fetch(url, { headers: { Accept: 'application/json' }, signal: this.ctrl.signal });
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();
      const items = (data.resources && data.resources.results && data.resources.results.products) || [];
      this.box.textContent = '';
      if (!items.length) {
        const p = document.createElement('p'); p.className = 'lsearch__empty muted';
        p.textContent = (window.itira.strings.searchNone || 'No pieces found for') + ' “' + q + '”';
        this.box.appendChild(p);
      }
      items.forEach((it) => {
        const a = document.createElement('a'); a.className = 'lsearch__item'; a.href = it.url; a.setAttribute('role', 'option');
        if (it.image) { const im = document.createElement('img'); im.src = it.image; im.alt = ''; im.loading = 'lazy'; im.width = 56; im.height = 70; a.appendChild(im); } else { a.appendChild(document.createElement('span')); }
        const t = document.createElement('span'); t.textContent = it.title; a.appendChild(t);
        const pr = document.createElement('span'); pr.className = 'muted'; pr.textContent = it.price ? (window.itira.strings.currency || '₹') + Number(it.price).toLocaleString('en-IN') : ''; a.appendChild(pr);
        this.box.appendChild(a);
      });
      this.box.hidden = false; this.input.setAttribute('aria-expanded', 'true');
      if (this.status) this.status.textContent = items.length + ' results';
    } catch (err) { if (err.name !== 'AbortError') this.close(); }
  }
}
if (!customElements.get('live-search')) customElements.define('live-search', LiveSearch);
